import React from 'react';
import { Avatar, Badge, Button, Card } from 'antd';
import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Image from '../../../assets/images/react-js.jpg'
const { Meta } = Card;

const CourseCard = ({ tags = [], isCourseCompleted, enrollmentId, id, title, description, imageSrc, label = "" }) => {
    const navigate = useNavigate();
    const card = <Card
        className='cursor-pointer transition-all hover:shadow-2xl'
        cover={<img alt="course" className='aspect-video object-cover' src={imageSrc || Image} />}
    >
        <Meta
            title={title}
            description={
                <div className="line-clamp-2 overflow-hidden text-ellipsis">
                    {description}
                </div>
            } />
        <div className="flex gap-4 justify-end mt-4">
            {isCourseCompleted ? <Button onClick={() => navigate(`/dashboard/certificate/${enrollmentId}`)} >Certificate</Button> : null}
            <Button variant='filled' onClick={() => navigate(`/dashboard/enrollments/${enrollmentId}`)} >View Course</Button>
        </div>
    </Card>
    return (
        label ?
            <Badge.Ribbon text={[...tags.slice(0, 2), "And More!"].join(" + ")}
            >
                {card}
            </Badge.Ribbon> : card

    )
};

export default CourseCard;
